import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

import AppLayout from "../components/layout/AppLayout";
import MainLayout from "../components/layout/MainLayout";
import PrivateRoute from "./PrivateRoute";

/* 📌 Páginas */
const Login = lazy(() => import("../pages/LoginPage"));
const Dashboard = lazy(() => import("../pages/DashboardPage"));
const Inicio = lazy(() => import("../pages/MapaPage"));
const Usuarios = lazy(() => import("../pages/UsuariosPage"));
const Vehiculos = lazy(() => import("../pages/VehiculosPage"));
const Empresas = lazy(() => import("../pages/EmpresasPage"));
const Licencias = lazy(() => import("../pages/LicenciasPage"));
const Reportes = lazy(() => import("../pages/ReportesPage"));
const Permisos = lazy(() => import("../pages/PermisosPage"));
const NoAutorizado = lazy(() => import("../pages/NoAutorizadoPage"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Cargando...</div>}>
        <AppLayout />
      </Suspense>
    ),
    children: [
      /* 🔓 LOGIN */
      {
        index: true,
        element: <Login />,
      },

      /* 🔐 PRIVADAS */
      {
        element: <PrivateRoute />,
        children: [
          {
            element: <MainLayout />,
            children: [
              { path: "dashboard", element: <Dashboard /> },
              { path: "inicio", element: <Inicio /> },
              { path: "usuarios", element: <Usuarios /> },
              { path: "empresas", element: <Empresas /> },
              { path: "vehiculos", element: <Vehiculos /> },
              { path: "licencias", element: <Licencias /> },
              { path: "permisos", element: <Permisos /> },
              { path: "reportes", element: <Reportes /> }
            ],
          },
        ],
      },
    ],
  },

  /* 🚫 NO AUTORIZADO */
  {
    path: "/no-autorizado",
    element: (
      <Suspense fallback={<div>Cargando...</div>}>
        <NoAutorizado />
      </Suspense>
    ),
  },
]);